export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full max-w-md mx-auto lg:mx-0 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden bg-background-950 p-4">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20floating%20in%20dark%20space%20displaying%20video%20streaming%20app%20interface%20with%20warm%20red%20and%20golden%20accent%20highlights%2C%20clean%20UI%20with%20video%20thumbnails%2C%20glowing%20screen%20on%20phone%2C%20minimalist%20product%20photography%2C%20soft%20ambient%20lighting%2C%20premium%20tech%20aesthetic&width=400&height=560&seq=app-mobile-01&orientation=portrait"
                alt="91免费视频网站移动端观看入口"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left order-1 lg:order-2">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
              移动端体验
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
              随时随地 · 高清在线观看
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              91免费视频网站全面适配移动端，无论您使用手机还是平板，都能享受91在线观看视频网站的高清流畅体验。随时随地打开浏览器，即可畅享海量免费视频资源，真正实现高清视频网站免费的移动观影自由。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start mb-6">
              {['高清画质自适应', '极速加载不缓冲', '跨设备无缝切换'].map((feat) => (
                <span key={feat} className="flex items-center gap-1.5 text-sm text-foreground-600 whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-checkbox-circle-fill text-xs"></i>
                  </span>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-android-line text-sm"></i>
                </span>
                Android 版
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-apple-line text-sm"></i>
                </span>
                iOS 版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}